import { ApiResponseValidationError } from './fetchers/validate-response';

export function logNetworkError(error: any, method: string, url: string, body: string | undefined) {
  // Fetching may fail due to bad connection or other expected issues.
  const errorMessage = typeof error === 'string' ? error : error.message;
  console.error(`Network error: ${errorMessage} ${method} ${url}`, url.includes('login') ? undefined : body);
}

export function logErrorIfBadRequest(status: number, method: string, url: string, body: string | undefined) {
  if (status === 400 || status === 500 || status === 501 || status === 502) {
    // Report bad requests, server errors, invalid urls and bad gateways (cloudfront for server is down)
    const endpoint = getMaskedEndpoint(url);
    console.error(
      `UI got ${status} from ${method} request sent to ${endpoint || url}`,
      url.includes('login') ? undefined : body,
      endpoint ? url : undefined,
    );
  }
}

/**
 * Report a response that was served with a success status but does not match the schema its
 * endpoint declares (PLT-5936).
 *
 * Nothing else reports this: the query client runs with `retry: false` and no global query
 * error handler, so a thrown fetch error becomes a per-component error state in the customer's
 * browser. The endpoint is masked so that all failures of one endpoint read as one recurring
 * problem rather than one per entity.
 */
export function logResponseValidationError(error: ApiResponseValidationError) {
  const endpoint = getMaskedApiPath(error.endpoint);
  console.error(`Unexpected response shape from ${endpoint}`, error);
}

function getMaskedEndpoint(url: string): string | undefined {
  const endpointStart = url.indexOf('/api');
  if (endpointStart === -1) {
    return;
  }
  return getMaskedApiPath(url.substring(endpointStart));
}

/**
 * Replace the parts of an API path that vary per request (entity uids, product codes, releases,
 * numeric ids, query strings) with placeholders, so that the path can be used as a grouping key.
 */
function getMaskedApiPath(endPoint: string): string {
  const uidRegex = /(\/(?:p-|g-)?[0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12})/g;
  const productRegex = /(\/[A-Z]{5})/g;
  const idRegex = /(\/\d+)/g;
  const versionRegex = /(\/master|\/\d+\.\d+\.\d+)/g;
  const paramsRegex = /(\?.*)/;
  const maskedEndpoint = endPoint
    .replace(uidRegex, '/UID')
    .replace(productRegex, '/MASK')
    .replace(versionRegex, '/VERSION')
    .replace(idRegex, '/ID')
    .replace(paramsRegex, '?PARAMS');
  return maskedEndpoint;
}
